import basicAppConfig from "@next-platform/client-common-core/infra/constants/basicAppConfig";

import { ISPARTNER_LOCALSTORAGE_KEY } from "@/constants";
import { typedLocalStorageService } from "@/utils/localStorageRe";

export function getIsPartner() {
  return basicAppConfig.isPartnerApp || typedLocalStorageService.getItem(ISPARTNER_LOCALSTORAGE_KEY) === "true";
}

export default getIsPartner;
